import type { ReferenceListsQuery } from '@revelio/data-access';

import type { GqlSelectionListKey, SelectionListState } from '../types';

type FlatReferenceSelectionListKey = Extract<
  GqlSelectionListKey,
  'highest_degree' | 'ethnicity' | 'gender' | 'seniority'
>;

type ReferenceListItem = {
  id: number;
  name: string;
};

const referenceListConfig = [
  ['highest_degree', 'highestDegree'],
  ['ethnicity', 'ethnicity'],
  ['gender', 'gender'],
  ['seniority', 'seniority'],
] as const satisfies readonly [
  FlatReferenceSelectionListKey,
  keyof ReferenceListsQuery,
][];

const normalizeReferenceItem = (item: ReferenceListItem) => ({
  id: String(item.id),
  shortName: item.name,
  longName: item.name,
  label: item.name,
});

export const normalizeReferenceLists = (
  data: ReferenceListsQuery | null | undefined
): Partial<SelectionListState<FlatReferenceSelectionListKey>> | null => {
  if (!data) return null;

  return referenceListConfig.reduce<
    Partial<SelectionListState<FlatReferenceSelectionListKey>>
  >((acc, [selectionListKey, queryKey]) => {
    const nonNull = data[queryKey].filter(
      (item): item is ReferenceListItem => item !== null
    );
    acc[selectionListKey] = nonNull.map(normalizeReferenceItem);
    return acc;
  }, {});
};
